Tooltip = require 'components/common/tooltip'

InfoIconWithTooltip = (props) ->
  <Tooltip>
    <span className="context-help-icon" title={props.info} />
  </Tooltip>

module.exports = InfoIconWithTooltip
